import { REGEX_CONSTANTS } from 'constants/regex';
import { ACTIVATION, FORM_ERROR_NOTIFIED } from 'constants/segmentEvents';
import moment from 'moment';
import { track } from 'utils/segmenTracker';
import { removeWhiteSpace } from 'utils/utils';

export const ISO_COUNTRY_CODES = {
  PARAGUAY: 'PY',
  ARGENTINA: 'AR',
  BOLIVIA: 'BO',
  BRASIL: 'BR',
  CHILE: 'CL',
  COLOMBIA: 'CO',
  URUGUAY: 'UY',
  VENEZUELA: 'VE',
  'ESTADOS UNIDOS': 'US',
  MEXICO: 'MX',
  ALEMANIA: 'DE',
  CANADA: 'CA',
  ESPAÑA: 'ES',
  FRANCIA: 'FR',
  LIBANO: 'LB',
  'REINO UNIDO': 'GB',
};

export const DOCUMENT_TYPES = {
  CI: 'CI',
  RUC: 'RU',
  DE: 'DE',
};

export const getCreateLeadParams = (params) => {
  const { pha_data } = localStorage.getItem('auth') ? JSON.parse(atob(localStorage.getItem('auth'))) : {};
  return {
    activateService: {
      createBasketAndAddItemsMutation: {
        basketCreateMutation: {
          included: {
            newInstance: {
              attributes: {
                lastStep: 'created',
                salesContext: {
                  salespersonId: pha_data?.id || '',
                  salespersonCode: pha_data?.salesforceId || '460',
                },
              },
            },
          },
        },
      },
      createCustomerMutation: {
        individualsCreateMutation: {
          included: {
            newInstance: {
              attributes: {
                givenName: `${params.cliFirstName}`.toUpperCase(),
                familyName: `${params.cliLastName}`.toUpperCase(),
              },
              included: {
                contactMedia: [
                  {
                    attributes: {
                      role: 'owner',
                      mediumType: 'telephoneNumber',
                      medium: {
                        telephoneNumber: {
                          number: `5959${params.cliTelephone?.replace(/[- )(]/g, '')}`,
                        },
                      },
                    },
                  },
                  {
                    attributes: {
                      role: 'owner',
                      mediumType: 'email',
                      medium: {
                        email: params.cliEmail,
                      },
                    },
                  },
                ],
                identifications: [
                  {
                    attributes: {
                      identificationId: params.documentNumber,
                      identificationType: DOCUMENT_TYPES[params.documentType],
                      issuingAuthority: {
                        country:
                          !params.cliNationality || params.cliNationality === 'Nacionalidad'
                            ? 'PY'
                            : ISO_COUNTRY_CODES[params.cliNationality],
                      },
                    },
                  },
                ],
              },
            },
          },
        },
      },
    },
  };
};

export const formValidator = (formValues, errorUpdateCallback, setError) => {
  let error = false;
  const auth = localStorage.getItem('auth') ? JSON.parse(atob(localStorage.getItem('auth'))) : {};

  Object.entries(formValues).forEach(([key, value]) => {
    console.log('Validating', key, value);
    switch (key) {
      case 'cliTelephone': {
        const isValidTelephone =
          value && REGEX_CONSTANTS.PHONE_NUMBER.test(removeWhiteSpace(value)) && value.length === 8;
        !isValidTelephone && errorUpdateCallback({ id: key, value: true });
        if (!isValidTelephone) {
          error = true;
          track(FORM_ERROR_NOTIFIED, { form_field: 'Número celular', journey: ACTIVATION });
        }
        if (removeWhiteSpace(value) === auth?.pos_msisdn.substr(4)) {
          error = true;
          errorUpdateCallback({
            id: key,
            value: 'true',
          });
          setError('El número de celular no puede ser igual al número de la cuenta.');
        }
        return;
      }
      default:
        return null;
    }
  });
  return error;
};

export const formatFormFields = (fields, valueToCheck, disableNameFields, disableAllFields) => {
  let formattedFields = [...fields];

  if (disableNameFields) {
    formattedFields = formattedFields.map((field) => {
      if (['cliFirstName', 'cliLastName', 'dateOfBirth'].includes(field.name)) {
        return { ...field, disabled: true };
      } else return field;
    });
  }

  if (disableAllFields) {
    formattedFields = formattedFields.map((field) => {
      if (field.components) {
        field.components = field.components.map((eachComponent) => {
          eachComponent.component = eachComponent.component.map((c) => {
            if (['documentType', 'documentNumber'].includes(c.name)) {
              return { ...c, disabled: true };
            } else return c;
          });
          return eachComponent;
        });
      } else if (field.type === 'button') {
        return { ...field };
      }
      return { ...field, disabled: true };
    });
  } else {
    formattedFields = formattedFields.map((field) => {
      if (field.components) {
        field.components = field.components.map((eachComponent) => {
          eachComponent.component = eachComponent.component.map((c) => {
            if (['documentType', 'documentNumber'].includes(c.name)) {
              return { ...c, disabled: false };
            } else return c;
          });
          return eachComponent;
        });
      }
      return { ...field };
    });
  }

  if (valueToCheck.documentType === 'DE')
    return formattedFields.map((field) => {
      if (field.name === 'cliNationality') {
        if (valueToCheck.cliNationality === 'Nacionalidad') {
          return { ...field, label: '' };
        } else return { ...field, label: 'Nacionalidad' };
      } else {
        return { ...field };
      }
    });
  else return formattedFields.filter((field) => field.conditionalDisplay !== true);
};

export const getDocUploadParams = (params) => {
  return {
    activateService: {
      createBasketAndAddItemsMutation: {
        basketCreateMutation: {
          included: {
            newInstance: {
              attributes: {
                leadStep: 'document',
              },
            },
          },
        },
      },
      createCustomerMutation: {
        individualsCreateMutation: {
          included: {
            newInstance: {
              included: {
                identifications: [
                  {
                    attributes: {
                      identificationId: params?.documentNumber,
                      identificationType: DOCUMENT_TYPES[params?.documentType],
                      country: params?.country || ISO_COUNTRY_CODES[params?.cliNationality],
                      dateOfBirth: params?.dateOfBirth ? moment(params.dateOfBirth).format('YYYYMMDD') : '',
                    },
                  },
                ],
              },
            },
          },
        },
      },
    },
  };
};
